import { render, staticRenderFns } from "./businessCooperation.vue?vue&type=template&id=730a844c&scoped=true"
import script from "./businessCooperation.vue?vue&type=script&lang=js"
export * from "./businessCooperation.vue?vue&type=script&lang=js"
import style0 from "./businessCooperation.vue?vue&type=style&index=0&id=730a844c&prod&scoped=true&lang=less"
import style1 from "./businessCooperation.vue?vue&type=style&index=1&id=730a844c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730a844c",
  null
  
)

export default component.exports